// 路由白名单
const whiteList = [
  "",
  "/",
  "/login",
  "/home",
  "/redirection",
  "/integralCenter/throw",
  "/integralCenter/home",
]

// 子页面权限映射
const parentPath = {
  "/draw": "/integralCenter/integralCenter/shopDecoration",
  "/integralCenter/cardManage/scratchersEdit": "/integralCenter/cardManage/scratchers",
  "/integralCenter/cardManage/smartPosterEdit": "/integralCenter/cardManage/smartPoster",
  "/integralCenter/cardManage/memberCardEdit": "/integralCenter/cardManage/memberCard",
  "/integralCenter/cardManage/freeTrialEdit": "/integralCenter/cardManage/freeTrial",
  "/integralCenter/lock_auth_throw":"/integralCenter/integralEden/pointLockAuth"
}

export const checkPermisson = (path) => {
  if(whiteList.includes(path)) {
    return true
  } else {
    const permission = JSON.parse(localStorage.getItem("permissionPath_jhk")) || []
    if(permission.includes(path)) {
      return true
    } else {
      // 存在子页面判断权限的情况
      if(permission.includes(parentPath[path])) {
        return true
      } 
      return false
    }
  }
}